import * as React from "react";
import { Subject, Subscription } from "rxjs";
import { isNullOrUndefined } from "components/utils";
import { Resources } from "../utils/PermissionsUtils";

declare var _globals: any;

export interface User {
    Id: string;
    UserName: string;
    Prijmeni: string;
    Jmeno: string;
    Email: string;
    IsAdmin: boolean;
    Sudo?: string;
    Resources: { [index: number]: boolean }
}

class UserManager {

    readonly state$: Subject<User> = new Subject();
    private logedUser: User;

    constructor() {
        this.setUser(_globals.logedUser);
    }

    private pushUser = () => this.state$.next(this.getUser());

    public setUser = (user?: User) => {
        this.logedUser = user;
        this.pushUser();
    }

    public getUser = (): User => this.logedUser;

    public subscribe = (f: (u: User) => void): Subscription => this.state$.subscribe(f);
}

export const userManager = new UserManager;

export const userHasPermissions = (user: User, resource: Resources, readAndWrite: boolean) => {

    if (isNullOrUndefined(user)) {
        user = userManager.getUser();
    }

    if (isNullOrUndefined(user) || isNullOrUndefined(user.Resources))
        return false;

    const rw = user.Resources[Resources.Administrator] || user.Resources[resource];

    return readAndWrite ? rw === true : rw !== undefined;
}

export interface LogedUserProps {
    logedUser?: User;
}

export function withLogedUser<TP>(WrappedComponent: React.ComponentClass<TP & LogedUserProps>) {

    return class Connect extends React.Component<TP, LogedUserProps> {

        private stateSubs: Subscription;

        constructor(props: TP) {
            super(props);
        };

        componentWillMount() {
            this.stateSubs = userManager.subscribe(user => {
                this.setState({ logedUser: user });
            });
            this.setState({ logedUser: userManager.getUser() });
        }

        componentWillUnmount() {
            this.stateSubs.unsubscribe();
        }

        render() {
            return React.createElement(WrappedComponent, Object.assign({}, this.props, this.state));
        }
    }
}


